var map = {
	"./1.jpg": 9974,
	"./2.jpg": 7729,
	"./3.jpg": 3396,
	"./4.jpg": 1183,
	"./5.jpg": 3122,
	"./6.jpg": 5405,
	"./7.jpg": 6832,
	"./8.jpg": 8443,
	"./mainImg.jpg": 215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6224;